import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import type {BuyHistoryDto} from '../../common/shared/api/nicolas/vo/BuyHistoryDto.interface';

/**
 * 이용권 구매 내역 조회
 *
 * Origin: pageNicolasApi.getTicketHistoryBuy
 * API: GET /api/v1/ticket/history/buy
 */
export async function getTicketHistoryBuy(
  params: {
    seriesId: number;
    page?: number;
  },
  options?: FetcherOptions
): Promise<
  ApiResultV2Vo<{
    list?: BuyHistoryDto[];
    is_end?: boolean;
    total_count?: number;
  }>
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/history/buy',
    {
      method: 'GET',
      params: {
        series_id: params.seriesId,
        page: params.page ?? 0,
      },
    },
    options
  );
  return response.data;
}
